"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAriaSummary = void 0;

var _constants = require("./constants");

var getAriaSummary = function getAriaSummary(progressSummary, status, threshold) {
  if (progressSummary !== undefined) {
    return progressSummary;
  }

  var statusText = !!status ? status : 'neutral';

  if (threshold !== undefined) {
    return "".concat(statusText, " with threshold at ").concat((0, _constants.formatProgress)(threshold), "%.");
  }

  return "".concat(statusText);
};

exports.getAriaSummary = getAriaSummary;